export const instructions = {
  id: 0,
  part1: "Tap to reveal",
  message: "Swipe left/right to discard",
};

export const questions = [
  {
    id: 1,
    message:
      "If you didn't have to sleep, what would you do with the extra time?",
  },
  {
    id: 2,
    message: "What's your favourite piece of clothing you own / owned?",
  },
  {
    id: 3,
    message:
      "What hobby would you get into if time and money weren't an issue?",
  },
  { id: 4, message: "What would your perfect room look like?" },
  { id: 5, message: "How often do you play sports?" },
  { id: 6, message: "What fictional place would you most like to go?" },
  { id: 7, message: "What job would you be terrible at?" },
  { id: 8, message: "When was the last time you climbed a tree?" },
  {
    id: 9,
    message:
      "If you could turn any activity into an Olympic sport, what would you have a good chance at winning a medal for?",
  },
  {
    id: 10,
    message: "What is the most annoying habit that other people have?",
  },
  { id: 11, message: "What job do you think you'd be really good at?" },
  { id: 12, message: "What skill would you like to master?" },
  { id: 13, message: "What would be the most amazing adventure to go on?" },
  {
    id: 14,
    message:
      "If you had unlimited funds to build a house that you would live in for the rest of your life, what would the finished house be like?",
  },
  { id: 15, message: "What's your favourite drink?" },
  { id: 16, message: "What state or country do you never want to go back to?" },
  { id: 17, message: "What songs have you completely memorized?" },
  {
    id: 18,
    message: "What game of movie universe would you most like to live in?",
  },
  { id: 19, message: "What do you consider to be your best find?" },
  { id: 20, message: "Are you usually early or late?" },
  { id: 21, message: "What do you consider to be your best find?" },
  { id: 22, message: "What pets did you have while you were growing up?" },
  { id: 23, message: "What takes up too much of your time?" },
  { id: 24, message: "What do you wish you knew more about?" },
  {
    id: 25,
    message:
      "What would be your first question after waking up from being cryogenically frozen for 100 years?",
  },
  { id: 26, message: "What are some small things that make your day better?" },
  {
    id: 27,
    message:
      "Who's you go to band or artist when you can't decide on something to listen to?",
  },
  { id: 28, message: "What shows are you into?" },
  { id: 29, message: "What TV channel doesn't exist but really should?" },
  {
    id: 30,
    message: "Who has impressed you most with what they've accomplished?",
  },
  { id: 31, message: "What age do you wish you could permanently be?" },
  { id: 32, message: "What TV show or movie do you refuse to watch?" },
  { id: 33, message: "What would be your ideal way to spend the weekend?" },
  {
    id: 34,
    message:
      "What is something that is considered a luxury, but you don't think you could live without?",
  },
  { id: 35, message: "What's your claim to fame?" },
  { id: 36, message: "What's something you like to do the old-fashioned way?" },
  { id: 37, message: "What's your favourite genre of book or movie?" },
  { id: 38, message: "How often do you people watch?" },
  { id: 39, message: "What have you only recently formed an opinion about?" },
  { id: 40, message: "What's the best single day on the calendar?" },
  {
    id: 41,
    message: "What are you interested in that most people haven't heard of?",
  },
  { id: 42, message: "How do you relax after a hard day of work?" },
  {
    id: 43,
    message: "What was the best book or series that you've ever read?",
  },
  { id: 44, message: "What's the farthest you've ever been from home?" },
  { id: 45, message: "What is the most heartwarming thing you've ever seen?" },
  {
    id: 46,
    message: "What is the most annoying question that people ask you?",
  },
  {
    id: 47,
    message:
      "What could you give a 40-minute presentation on with absolutely no preparation?",
  },
  {
    id: 48,
    message:
      "If you were a dictator of a small island nation, what crazy dictator stuff would you do?",
  },
  {
    id: 49,
    message:
      "What is something you think everyone should do at least once in their lives?",
  },
  {
    id: 50,
    message: "Would you rather go hang gliding or whitewater rafting?",
  },
  { id: 51, message: "What's your dream car?" },
  { id: 52, message: "What's worth spending more on to get the best?" },
  {
    id: 53,
    message:
      "What is something that a ton of people are obsessed with but you just don't get the point of?",
  },
  {
    id: 54,
    message: "What are you most looking forward to in the next 10 years?",
  },
  { id: 55, message: "Where is the most interesting place you've been?" },
  {
    id: 56,
    message:
      "What's something you've been meaning to try but just haven't gotten around to it?",
  },
  {
    id: 57,
    message: "What's the best thing that's happened to you last week?",
  },
  {
    id: 58,
    message:
      "What piece of entertainment do you wish you could erase from your mind so that you could experience it for the first time again?",
  },
  {
    id: 59,
    message:
      "If all jobs had the same pay and hours, what job would you like to have?",
  },
  {
    id: 60,
    message: "What amazing thing did you do that no one was around to see?",
  },
  { id: 61, message: "How different was your life one year ago?" },
  { id: 62, message: "What's the best way to start the day?" },
  { id: 63, message: "What quirks do you have?" },
  { id: 64, message: "What would you rate 10/10?" },
  { id: 65, message: "What fad or trend you do hope comes back?" },
  { id: 66, message: "What's the most interesting piece of art you've seen?" },
  { id: 67, message: "What kind of art do you enjoy most?" },
  { id: 68, message: "What do you hope never changes?" },
  { id: 69, message: "What city would you most like to live in?" },
  { id: 70, message: "What movie title best describes your life?" },
  { id: 71, message: "Why did you decide to do the work you are doing now?" },
  { id: 72, message: "What's the best way a person can spend their time?" },
  {
    id: 73,
    message:
      "If you suddenly became a master at woodworking, what would you make?",
  },
  { id: 74, message: "Where is the most relaxing place you've ever been?" },
  { id: 75, message: "What is the luckiest thing that has happened to you?" },
  { id: 76, message: "Where would you rather be from?" },
  { id: 77, message: "What are some things you've had to unlearn?" },
  { id: 78, message: "What are you looking forward to in the coming months?" },
  { id: 79, message: "What website do you visit most often?" },
  { id: 80, message: "What one thing do you really want but can't afford?" },
  { id: 81, message: "Where do you usually go when you have time off?" },
  { id: 82, message: "Where would you spend all your time off if you could?" },
  { id: 83, message: "What is special about the place you grew up?" },
  { id: 84, message: "What age do you want to live to?" },
  { id: 85, message: "What are you most likely to become famous for?" },
  { id: 86, message: "What are you absolutely determined to do?" },
  { id: 87, message: "What is the most impressive thing you know how to do?" },
  { id: 88, message: "What do you wish you knew more about?" },
  {
    id: 89,
    message: "What question would you most like to know the answer to?",
  },
  {
    id: 90,
    message: "What question can you ask to find out the most about a person?",
  },
  {
    id: 91,
    message:
      "When was the last time you changed your opinion or belief about something major?",
  },
  { id: 92, message: "What was the best compliment you've ever recieved?" },
  { id: 93, message: "As the only human left on Earth, what would you do?" },
  { id: 94, message: "Who inspires you to be better?" },
  { id: 95, message: "What do you want your epitaph to be?" },
  { id: 96, message: "What did you think you would grow out of but haven't?" },
  {
    id: 97,
    message:
      "In what situation or place would you feel the most out of place in?",
  },
  {
    id: 98,
    message:
      "What's the dumbest thing you've done that actually turned out pretty well?",
  },
  {
    id: 99,
    message:
      "They say that everyone has a book in them. What would your book be about?",
  },
  { id: 100, message: "What is something you will NEVER do again?" },
  { id: 101, message: "What do you spend the most time thinking about?" },
  {
    id: 102,
    message:
      "What are some of the events in your life that made you who you are?",
  },
  { id: 103, message: "What do you wish your brain was better at doing?" },
  {
    id: 104,
    message:
      "There are two types of people in this world. What are the two types?",
  },
  {
    id: 105,
    message: "What is the strangest thing you have every come across?",
  },
  {
    id: 106,
    message: "What is something you are certain you'll never experience?",
  },
  { id: 107, message: "What dumb accomplishment are you most proud of?" },
  {
    id: 108,
    message:
      "If you could make one rule that everyone had to follow, what rule would you make?",
  },
  { id: 109, message: "What are you addicted to?" },
  { id: 110, message: "What stereotype do you completely live up to?" },
  { id: 111, message: "What is something you can never seem to finish?" },
  {
    id: 112,
    message: "As you get older, what are you becoming more and more afraid of?",
  },
  { id: 113, message: "What is one of your favourite smells?" },
  { id: 114, message: "What would be the scariest monster you could imagine?" },
  {
    id: 115,
    message: "What song or artist do you like but rarely admit to liking?",
  },
  {
    id: 116,
    message: "What would you do if you knew you were going to die in one hour?",
  },
  { id: 117, message: "What book impacted you the most?" },
  {
    id: 118,
    message: "If you had to change your name, what would you change it to?",
  },
  {
    id: 119,
    message:
      "If life is a game, like some people say, what are some of the rules?",
  },
  { id: 120, message: "Who is / was your most interesting friend?" },
  { id: 121, message: "Have you ever given to any charities?" },
  {
    id: 122,
    message: "What is something that your friends would consider 'so you'?",
  },
  { id: 123, message: "What risks are worth taking?" },
  {
    id: 124,
    message: "What can you not get right, no matter how many times you try?",
  },
  {
    id: 125,
    message:
      "If you could convince everyone in the world to do one thing at one point in time, what would that be?",
  },
  { id: 126, message: "What do you take for granted?" },
  {
    id: 127,
    message:
      "What would be some of the most annoying things about having yourself as a roommate?",
  },
  { id: 128, message: "What's something you are self-concious about?" },
  {
    id: 129,
    message:
      "What personality trait do you value most and which do you dislike the most?",
  },
  {
    id: 130,
    message: "What small gesture from a stranger made a big impact on you?",
  },
  { id: 131, message: "What gets you fired up?" },
  {
    id: 132,
    message: "What challenging thing are you working through these days?",
  },
  { id: 133, message: "What irrational fear do you have?" },
  {
    id: 134,
    message: "What's the best and worst piece of advice you've ever received?",
  },
  {
    id: 135,
    message:
      "If you had a clock that would countdown to any one event of your choosing, what event would you pick?",
  },
  { id: 136, message: "What makes a good life?" },
  { id: 137, message: "What do you strongly suspect but have no proof of?" },
  { id: 138, message: "What's the last adventure you went on?" },
  { id: 139, message: "When do you feel truly 'alive'?" },
  { id: 140, message: "What was the most memorable gift you've received?" },
  {
    id: 141,
    message: "What chapters would you separate your autobiography into?",
  },
  { id: 142, message: "What do you like most about your family?" },
  { id: 143, message: "What do you hope your last words will be?" },
  { id: 144, message: "What stat for your life would you most like to see?" },
  {
    id: 145,
    message: "What are three of the most significant numbers in your life?",
  },
  {
    id: 146,
    message:
      "What could you do with two million dollars to impact the most amount of people?",
  },
  {
    id: 147,
    message:
      "If you were put into solitary confinement for six months, what would you do to stay sane?",
  },
  {
    id: 148,
    message:
      "What's something horrible that everyone should try at least once?",
  },
  { id: 149, message: "What fact are you resigned to?" },
  { id: 150, message: "Have you ever saved someone's life?" },
  { id: 151, message: "What were some of the turning points in your life?" },
  { id: 152, message: "What would a mirror opposite of yourself be like?" },
  {
    id: 153,
    message:
      "What are you really good at, but kind of embarrassed that you are good at it?",
  },
  { id: 154, message: "What are three interesting facts about you?" },
  { id: 155, message: "Which of your scars has the best story behind it?" },
  { id: 156, message: "What's the title of the current chapter of your life?" },
  { id: 157, message: "What's the hardest lesson you've learned?" },
  { id: 158, message: "What mistake do you keep making again and again?" },
  { id: 159, message: "What do people think is weird about you?" },
  {
    id: 160,
    message: "When people look at you, what do you think they see / think?",
  },
  { id: 161, message: "What have you created that you are most proud of?" },
  {
    id: 162,
    message:
      "If you could make a 20s phone call to yourself at any point in your life, when would you call and what would you say?",
  },
  {
    id: 163,
    message: "What annoys you most about the in-groups you are a part of?",
  },
  { id: 164, message: "What do you have doubts about?" },
  { id: 165, message: "What do you want to be remembered for?" },
  {
    id: 166,
    message: "What are some of your personal 'rules' that you never break?",
  },
  {
    id: 167,
    message: "What do you regret not doing or starting when you were younger?",
  },
  {
    id: 168,
    message:
      "If you could have a never ending candle that smelled like anything you wanted, what fragrance would you choose?",
  },
  { id: 169, message: "What's the best thing about you?" },
  { id: 170, message: "What bends your mind every time you think about it?" },
  { id: 171, message: "What's the best thing you got from your parents?" },
  {
    id: 172,
    message: "What's one responsibility you really wish you didn't have?",
  },
  { id: 173, message: "What's the 'holy grail' of your life?" },
  { id: 174, message: "If your childhood had a smell, what would it be?" },
  {
    id: 175,
    message:
      "What are the top three things you want to accomplish before you die? How close are you to accomplishing them?",
  },
  {
    id: 176,
    message:
      "What do you wish you could tell yourself 10 years ago? What do you think you'll want to tell your current self 10 years from now?",
  },
  { id: 177, message: "In your group of friends, what role do you play?" },
  {
    id: 178,
    message: "Among your friends and family, what are you famous for?",
  },
  { id: 179, message: "What is the biggest lesson you never learned?" },
  { id: 180, message: "What's the most immature thing you do?" },
  { id: 181, message: "If your life was a book, what would its title be?" },
  { id: 182, message: "What's the best and worst thing about getting older?" },
  {
    id: 183,
    message:
      "What's something that happened or something that someone said that changed how you view the world?",
  },
  { id: 184, message: "What are you most likely very wrong about?" },
  { id: 185, message: "If you had a personal flag, what would be on it?" },
  {
    id: 186,
    message:
      "What lifestyle change have you been meaning to make for a while now?",
  },
  { id: 187, message: "What would be your spirit animal?" },
  {
    id: 188,
    message:
      "What incredibly strong opinion or belief do you have that is completely unimportant in the grand scheme of things?",
  },
  { id: 189, message: "What chance encounter changed your life forever?" },
  {
    id: 190,
    message:
      "If you could have a video of any one event in your life, what event would you choose?",
  },
  {
    id: 191,
    message:
      "If you were forced to relive one 10min block of your life on loop for all eternity, what 10mins of your life would you choose?",
  },
];
